import { AType, summon } from "@silversea-ssc/functional-support"
import * as F from "fp-ts/function"
import * as N from "fp-ts/number"
import * as ORD from "fp-ts/Ord"

const _AvailabilityType = summon((F) => F.keysOf({ standard: null, guaranteed: null, partial: null }))
export type AvailabilityType = AType<typeof _AvailabilityType>

const standardFirsPriorityMap: Record<AvailabilityType, number> = { standard: 1, guaranteed: 2, partial: 3 }
const byPriority = F.pipe(
    N.Ord,
    ORD.contramap((x: AvailabilityType) => standardFirsPriorityMap[x]),
)

export const AvailabilityType = Object.assign(_AvailabilityType, {
    match: <T>(standard: () => T, guaranteed: () => T, partial: () => T) => {
        const matches = { standard, guaranteed, partial }
        return (availabilityType: AvailabilityType): T => matches[availabilityType]()
    },
    matchConstant: <T>(standard: T, guaranteed: T, partial: T) =>
        AvailabilityType.match(F.constant(standard), F.constant(guaranteed), F.constant(partial)),
    byPriority,
})
